//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import jK from './assets/js/common';
Vue.use(VueClipboard)

export default {
  name: 'App',
  data(){
    return {
      loadingShow:false,
      stLoading:null,
      tipText:'',
      tipShow:false,
    }
  },
  mounted(){
    jK.event.$on('loadingShow',(state)=>{
      clearTimeout(this.stLoading)
      if(state){
        this.stLoading = setTimeout(()=>{
          this.loadingShow = true;
        },500)
      }
      else{
        this.loadingShow = false;
      }
    })
    jK.event.$on('tip',(payload)=>{
      this.tipText = payload.text||payload;
      this.tipShow = true;
      setTimeout(()=>{
        this.tipShow = false;
        this.tipText = '';
      },payload.time||3000)
    })
    jK.event.$on('playerShow',(state)=>{
      this.playerShow = state;
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue